import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';

import DimensionRange from './DimensionRange';
import ArrayUtil from '../../../utils/ArrayUtil';

class CognitiveBenchmarks extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: ['cognitive'],
    };
  }

  render() {
    const {
      benchmarks, isEdit, onChange, hintsCS, hintsJPS, hintsSJL,
    } = this.props;
    const { expanded } = this.state;
    // get concurrent study hints
    const csBenchmarks = hintsCS && ArrayUtil.isNotEmpty(hintsCS) ? hintsCS : [];

    // get job profile survey hints
    const jpsBenchmarks = hintsJPS && ArrayUtil.isNotEmpty(hintsJPS) ? hintsJPS : [];

    // get standard job hints
    const sjlBenchmarks = hintsSJL && ArrayUtil.isNotEmpty(hintsSJL.behaviorStandardJobBenchmarks)
      ? hintsSJL.cognitiveStandardJobBenchmarks
      : [];

    if (!benchmarks || ArrayUtil.isEmpty(benchmarks.dimensionBenchmarks)) return null;

    let { dimensionBenchmarks } = benchmarks;
    dimensionBenchmarks = dimensionBenchmarks.slice();
    dimensionBenchmarks = ArrayUtil.sortBenchMarksAlphabet(dimensionBenchmarks).map(d => ({
      dimensionRange: d,
      hintCSRange: csBenchmarks.filter(h => h.dimensionName === d.code)[0],
      hintJPSRange: jpsBenchmarks.filter(h => h.dimensionName === d.code)[0],
      hintSJLRange: sjlBenchmarks.filter(h => h.dimensionName === d.code)[0],
    }));

    return (
      <div className="accordion-legacy-container">
        <Accordion preExpanded={expanded} allowZeroExpanded>
          <AccordionItem uuid="cognitive">
            <AccordionItemHeading>
              <AccordionItemButton>
                <span className="t-large">{benchmarks.displayName}</span>
              </AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel className="accordion-panel">
              <div className="abilityContainer">
                {dimensionBenchmarks.map(d => (
                  <DimensionRange
                    key={`${d.code}`}
                    dimensionRange={d.dimensionRange}
                    hintCSRange={d.hintCSRange}
                    hintJPSRange={d.hintJPSRange}
                    hintSJLRange={d.hintSJLRange}
                    isEdit={isEdit}
                    onChange={(...rest) => onChange(...rest, 'cognitiveBenchmarks')}
                  />
                ))}
              </div>
            </AccordionItemPanel>
          </AccordionItem>
        </Accordion>
      </div>
    );
  }
}

CognitiveBenchmarks.propTypes = {
  benchmarks: PropTypes.objectOf(PropTypes.any).isRequired,
  isEdit: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  hintsCS: PropTypes.arrayOf(PropTypes.any),
  hintsJPS: PropTypes.arrayOf(PropTypes.any),
  hintsSJL: PropTypes.arrayOf(PropTypes.any),
};

CognitiveBenchmarks.defaultProps = {
  hintsCS: [],
  hintsJPS: [],
  hintsSJL: [],
};

export default CognitiveBenchmarks;
